import { PictogramImage } from "./PictogramImage";

export const CompactPictogramTile = ({ pictogram, onOpen, testId, imageTestId, nameTestId, badge, badgeTestId }) => (
  <button type="button" onClick={onOpen} aria-label={`Modifica ${pictogram.name}`} title={pictogram.name}
    className="group flex w-full min-w-0 min-h-[124px] flex-col items-center gap-2 border border-[#D4D4D4] bg-white px-2.5 py-3 text-center transition-colors hover:border-[#1A1A1A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1A1A1A]"
    data-testid={testId}>
    <span className="flex h-14 w-14 shrink-0 items-center justify-center bg-[#F6F6F3]">
      <PictogramImage pictogram={pictogram} className="w-11 h-11" testId={imageTestId} />
    </span>
    <span className="w-full min-w-0 font-serif text-base leading-tight line-clamp-2 [overflow-wrap:anywhere]"
      data-testid={nameTestId}>{pictogram.name}</span>
    {badge && <span className="mt-auto text-[10px] text-[#525252]" data-testid={badgeTestId}>{badge}</span>}
  </button>
);